//import { angular } from '../utils';
enum State {
    unchanged,
    added,
    modified,
    deleted
}
interface IBaseEntity {
    id: number;
    state: State;
}
interface IBaseCode extends IBaseEntity {
    code: string;
    description: string
}
interface IRowVersion {
    rowVersion: number[];
    formattedRowVersion: string;
}
interface IWarningModel {
    warningMessage: string;
    warningType: number;
    ntisName: string;
}

/*interface ICustomInject extends angular.auto.IInjectorService {
    get<T>(name: string): T;
}

interface directiveScope extends ng.IScope {
    url: string;
    atrAutocomplete: number;
}
*/
enum StorageType {
    session,
    cookie,
    localStorage
}

interface ISearchResult<T> {
    data: Array<T>;
    total: number;
}

export { State, IBaseEntity, IBaseCode, IRowVersion, IWarningModel, /*ICustomInject, directiveScope, */StorageType, ISearchResult };